'use strict';

import { AdaptiveToneMappingPass } from '../../../libs/AdaptiveToneMappingPass'
import { Effect } from './Effect';
import { assignDeep } from '../../../settings';

const DEFAULT_PARAMS = {
  middleGrey: 0.6,
  maxLuminance: 16,
  averageLuminance: 1
};

export class ToneMapping extends Effect {
  constructor (params = {}) {
    super();
    const settings = assignDeep(DEFAULT_PARAMS,params);
    this.effect = new AdaptiveToneMappingPass(false);
    this.effect.setMiddleGrey(settings.middleGrey);
    this.effect.setMaxLuminance(settings.maxLuminance);
    this.effect.setAverageLuminance(settings.averageLuminance);
  }

  set config(conf) {
    this.effect.setMiddleGrey(conf.middleGrey);
    this.effect.setMaxLuminance(conf.maxLuminance);
    this.effect.setAverageLuminance(conf.averageLuminance);
    this.active = conf.hasOwnProperty('enabled') ? conf.enabled : conf.active;
  }
}
